// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useEffect } from 'react';

export default function RedirectLink(props: { url: string }) {
  useEffect(() => {
    window.location.href = props.url;
  });

  return null;
}
